import { createI18n } from "vue-i18n";
import fr from "./translations/fr.json";
import en from "./translations/en.json";

const i18n = createI18n({
  locale: "en-LU",
  mode: "composition",
  globalInjection: true,
  legacy: false,

  messages: {
    "en-LU": en,
    "fr-LU": fr
  },
});

export default i18n;
